<template>
  <div class="headline-teaser | headline headline--type_teaser headline--type_h1">
    <slot />
  </div>
</template>
